module.exports = require('../impls/$flat-map/async-flat-map.js').asyncFlatMap;